import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { TextBoxContent as TextBoxContent$2 } from './style.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "className", "center", "noMaxWidth"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TextBoxContent = function TextBoxContent(_ref) {
  var children = _ref.children,
    className = _ref.className,
    center = _ref.center,
    noMaxWidth = _ref.noMaxWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!children) {
    return false;
  }
  return /*#__PURE__*/jsx(TextBoxContent$2, _objectSpread(_objectSpread({
    className: className,
    noMaxWidth: noMaxWidth,
    center: center
  }, rest), {}, {
    children: children
  }));
};
TextBoxContent.defaultProps = {
  className: null,
  center: false,
  noMaxWidth: false
};
var TextBoxContent$1 = TextBoxContent;

export { TextBoxContent$1 as default };
//# sourceMappingURL=TextBoxContent.js.map
